import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup'; // 1. Import CountUp
import { collection, getCountFromServer, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export default function Testimonials() {
    const [users, setUsers] = useState(null);
    const [guides, setGuides] = useState(null);
    const [platforms, setPlatforms] = useState(null);
    
    // Track mobile state
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        async function fetchStats() {
            try {
                const userCountSnap = await getCountFromServer(collection(db, 'users'));
                const playbookSnap = await getDocs(collection(db, 'playbooks'));

                setUsers(userCountSnap.data().count);
                setGuides(playbookSnap.size);

                const domains = new Set();
                playbookSnap.forEach((doc) => {
                    const url = doc.data().universalUrl;
                    if (url) {
                        const hostname = new URL(url.startsWith('http') ? url : `https://${url}`).hostname;
                        domains.add(hostname.replace(/^www\./, ''));
                    }
                });
                setPlatforms(domains.size);
            } catch (e) {
                console.warn('Error:', e.message);
            }
        }
        fetchStats();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

   return (
        <section style={{...styles.section, top: isMobile ? 40 : 70}}>
            <div style={{
                ...styles.proof,
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
                width: isMobile ? '90%' : '100%',
            }}>
                
                {/* STAT 1: USERS */}
                <div style={{
                    ...styles.stat,
                    borderRight: isMobile ? 'none' : '1px solid var(--border)',
                    borderBottom: isMobile ? '1px solid var(--border)' : 'none'
                }}>
                    <div style={styles.statNum}>
                           {users !== null ? (
                            <CountUp end={users} duration={2.5} separator="," enableScrollSpy={true} scrollSpyOnce={true} />
                        ) : (
                            <span className="loading-pulse">---</span>
                        )}
                    </div>
                    <div style={styles.statLabel}>Early users</div>
                </div>

                {/* STAT 2: GUIDES */}
                <div style={{
                    ...styles.stat,
                    borderRight: isMobile ? 'none' : '1px solid var(--border)',
                    borderBottom: isMobile ? '1px solid var(--border)' : 'none'
                }}>
                    <div style={styles.statNum}>
                           {guides !== null ? (
                            <><CountUp end={guides} duration={3} enableScrollSpy={true} scrollSpyOnce={true} />+</>
                        ) : (
                            <span className="loading-pulse">---</span>
                        )}
                    </div>
                    <div style={styles.statLabel}>Guides shared</div>
                </div>

                {/* STAT 3: PLATFORMS */}
                <div style={{ ...styles.stat, borderRight: 'none' }}> 
                    <div style={styles.statNum}>
                          {platforms !== null ? (
                            <CountUp end={platforms} duration={3.5} enableScrollSpy={true} scrollSpyOnce={true} />
                        ) : (
                            <span className="loading-pulse">---</span>
                        )}
                    </div>
                    <div style={styles.statLabel}>Platforms covered</div>
                </div>

            </div>
        </section>
    );
}

const styles = {
  section: {
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background: 'var(--warm-cream)',
    padding: '40px 0px', // Increased padding for mobile breathing room
    position: "relative",
  },
  proof: {
    display: 'grid',
    width: '100%',
    maxWidth: '1200px',
    margin: '20px auto',
    background: 'white',
    borderRadius: 'var(--radius-lg)',
    boxShadow: '0 32px 80px rgba(26,31,54,0.12)',
    overflow: 'hidden',
  },
  stat: { 
    textAlign: 'center',
    padding: '3rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  statNum: {
    fontFamily: "'Sora', sans-serif",
    fontSize: 'clamp(2.2rem, 5vw, 3.5rem)', 
    fontWeight: 800, 
    color: 'var(--charcoal)',
    lineHeight: 1,
  },
  statLabel: {
    fontSize: '0.75rem', // Slightly smaller for better fit on narrow screens
    color: 'var(--text-light)',
    textTransform: 'uppercase', 
    letterSpacing: '0.12em',
    fontWeight: 600,
  },
};